import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface DropdownPersonHeaderProps {
  className?: string;
  title: string;
  description: string;
  avatar: ReactNode;
  accessory?: ReactNode;
}

/*
 * Style.
 */

const StyledHeaderDiv = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto;
  grid-column-gap: 12px;
  align-items: center;
`;

const StyledAvatarDiv = styled.div`
  grid-row: 1;
  grid-column: 1;
`;

const StyledInfoDiv = styled.div`
  grid-row: 1;
  grid-column: 2;

  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const StyledTitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-weight: ${fontWeights.semibold};
  ${ellipsis()};
`;

const StyledDescriptionDiv = styled.div`
  margin-top: 3px;

  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.verySmall};
  ${ellipsis()};
`;

const StyledAccessoryDiv = styled.div`
  grid-row: 1;
  grid-column: 3;
`;

const StyledChildrenDiv = styled.div`
  grid-row: 2;
  grid-column: 1 / span 3;
`;

/*
 * Component.
 */

export const DropdownPersonHeader: FC<DropdownPersonHeaderProps> = (props) => (
  <StyledHeaderDiv className={props.className}>
    <StyledAvatarDiv>{props.avatar}</StyledAvatarDiv>
    <StyledInfoDiv>
      <StyledTitleDiv>{props.title}</StyledTitleDiv>
      <StyledDescriptionDiv>{props.description}</StyledDescriptionDiv>
    </StyledInfoDiv>
    <StyledAccessoryDiv>{props.accessory}</StyledAccessoryDiv>
    <StyledChildrenDiv>{props.children}</StyledChildrenDiv>
  </StyledHeaderDiv>
);
